/**
 * Registration Page for trAInedup.ai
 * Provides user registration interface
 */

import React from 'react';
import { Layout } from '../components/common/Layout';
import { RegisterForm } from '../components/auth/RegisterForm';
import { SEOHead } from '../components/seo/SEOHead';

/**
 * Registration page component
 * Renders the registration form within the main layout
 */
export const RegisterPage: React.FC = () => {
  return (
    <Layout showFooter={false}>
      <SEOHead
        title="Create Account - trAInedup.ai"
        description="Feeling left behind by AI? Create your free trAInedup.ai account and start catching up today. No tech background required."
        noindex={true}
      />
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">
          <RegisterForm />
        </div>
      </div>
    </Layout>
  );
};

